var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMicrosoftEdge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2307,
    height: 2500,
    viewBox: "0 0 1000 1083.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3277BC",
    d: "M316.997 436.854h383.437c0-136.13-59.4-228.94-221.36-228.94C287.674 207.913 93.033 332.514.5 487.876 29.162 218.213 222.513.5 513.607.5 763.109.5 999.5 191.264 999.5 508.374v120.563H319.04c0 164.094 143.148 229.11 293.07 229.11 182.448 0 295.435-81.985 295.435-81.985v229.852s-127.548 77.477-330.852 77.477c-264.197 0-450.687-189.34-450.687-424.789 0-184.808 111.788-332.36 266.628-393.245-75.372 82.777-75.638 171.497-75.638 171.497z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftEdge);
export default __webpack_public_path__ + "static/media/microsoft-edge.bf4d550fcbdcaf82da5c2ceecb571ec4.svg";
export { ForwardRef as ReactComponent };